import { Suspense, lazy } from "react";
// components
import LoadingScreen from "../components/loading-screen";

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen width="100px" height="100px" />}>
      <Component {...props} />
    </Suspense>
  );

// AUTH
export const LoginPage = Loadable(lazy(() => import("../pages/auth/LoginPage")));

// DASHBOARD: GENERAL
export const GeneralAppPage = Loadable(lazy(() => import("../pages/dashboard/GeneralAppPage")));

// DASHBOARD: REPORT
export const GeneralReportPage = Loadable(lazy(() => import("../pages/dashboard/GeneralReportPage")));

// DASHBOARD: Desigination
export const DesiginationCreatePage = Loadable(lazy(() => import("../pages/dashboard/DesiginationCreatePage")));
export const DesiginationEditPage = Loadable(lazy(() => import("../pages/dashboard/DesiginationEditPage")));

// DASHBOARD: SETTINGS
export const SettingsCreatePage = Loadable(lazy(() => import("../pages/dashboard/SettingsCreatePage")));

// DASHBOARD: CUSTOMER
export const CustomerListPage = Loadable(lazy(() => import("../pages/dashboard/CustomerListPage")));
export const CustomerCreatePage = Loadable(lazy(() => import("../pages/dashboard/CustomerCreatePage")));
export const CustomerEditPage = Loadable(lazy(() => import("../pages/dashboard/CustomerEditPage")));
export const CustomerInfoPage = Loadable(lazy(() => import("../pages/dashboard/cutomerInfo/CustomerInfoPage")));

// Store
export const StorePage = Loadable(lazy(() => import("src/components/store/store")));
export const FranchiseThemePreviewPage = Loadable(lazy(() => import("src/components/store/themesList/franchiseThemePreview")));
export const ThemeEditPage = Loadable(lazy(() => import("src/components/store/themesList/ThemeEditPage")));

// Pages

export const PageListPage = Loadable(lazy(() => import("src/components/store/pages/PageListPage")));
export const PageCreatePage = Loadable(lazy(() => import("src/components/store/pages/PageCreatePage")));
export const PageEditPage = Loadable(lazy(() => import("src/components/store/pages/PageEditPage")));

// DASHBOARD: USER
export const UserListPage = Loadable(lazy(() => import("../pages/dashboard/UserListPage")));
export const UserAccountPage = Loadable(lazy(() => import("../pages/dashboard/UserAccountPage")));
export const UserCreatePage = Loadable(lazy(() => import("../pages/dashboard/UserCreatePage")));
export const UserEditPage = Loadable(lazy(() => import("../pages/dashboard/UserEditPage")));

// MAIN

// MENU
export const MenuDisplayPage = Loadable(lazy(() => import("../pages/dashboard/MenuDisplayPage")));
// DASHBOARD: ITEM
export const ItemCreatePage = Loadable(lazy(() => import("../pages/dashboard/ItemCreatePage")));
export const ItemEditPage = Loadable(lazy(() => import("../pages/dashboard/ItemEditPage")));

// DASHBOARD: CATEGORY
export const CategoryCreatePage = Loadable(lazy(() => import("../pages/dashboard/CategoryCreatePage")));
export const CategoryEditPage = Loadable(lazy(() => import("../pages/dashboard/CategoryEditPage")) );

export const Page500 = Loadable(lazy(() => import("../pages/Page500")));
export const Page403 = Loadable(lazy(() => import("../pages/Page403")));
export const Page404 = Loadable(lazy(() => import("../pages/Page404")));
